import _ from "lodash";
import { PureComponent, ReactNode } from "react";
import { connect } from "react-redux";
import { IWithHistoryProp, withHistory } from "../../shared/hoc/with-history";
import { hideDomainAccessModal } from "../../store/domain-access-modal/actions";
import { AppState } from "../../store/root-reducer";
import UpgradePlan from "../../svgs/upgrade-plan.svg";
import { DefaultModal } from "../common/default-modal";
import KuikaButton from "../ui-kit/kuika-button/kuika-button";
import "./domain-access-required-modal.scss";

declare let window: any;

interface IDomainAccessRequiredModalProps {
  isDomainAccessModalOpen: boolean;
  accessName: string | string[];
  hideDomainAccessModal: () => void;
}

interface IDomainAccessRequiredModalState {}

class DomainAccessRequiredModal extends PureComponent<
  IDomainAccessRequiredModalProps & IWithHistoryProp,
  IDomainAccessRequiredModalState
> {
  constructor(props: IDomainAccessRequiredModalProps & IWithHistoryProp) {
    super(props);
    this.state = {};
  }

  closeModal = () => {
    this.props.hideDomainAccessModal();
  };

  renderMessage = () => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 32,
          paddingTop: 24,
          paddingBottom: 12
        }}
      >
        <UpgradePlan />
        <span className="kuika-domain-access-modal__message-text">
          {this.props.accessName !== "WorkflowMultipleProjects" && "You have reached the subscription plan limits. "}
          {this.props.accessName === "Seat" ? (
            <>
              You have reach your max <b>user limit</b>. Please delete your current users or purchase upgrade before
              adding new users.
            </>
          ) : this.props.accessName === "WorkflowMultipleProjects" ? (
            <>
              Another process already exists in the same domain. You can create process to only one project in a domain.
            </>
          ) : (
            <>
              Upgrade your plan for{" "}
              {(this.props.accessName === "Screens" || this.props.accessName === "Actions") && "more "}{" "}
              <b>
                {_.isArray(this.props.accessName)
                  ? this.props.accessName.join(", ")
                  : this.props.accessName === "Backend API"
                    ? "Rest API"
                    : this.props.accessName}
              </b>
              .
            </>
          )}
        </span>
        {/* {(this.props.accessName === "Screens" || this.props.accessName === "Actions") && (
          <span style={{ color: "grey", paddingBottom: 24 }}>
            You can add {this.props.accessName === "Screens" ? "Screen" : "Action"} up to {this.props.accessName === "Screens" ? "10" : "20"}.
          </span>
        )} */}
        {this.renderExceededNumber()}
        {this.props.accessName !== "WorkflowMultipleProjects" && (
          <KuikaButton
            uppercase
            onClick={() => {
              this.props.navigator.gotoSubsciptions();
              this.closeModal();
            }}
          >
            Upgrade
          </KuikaButton>
        )}
      </div>
    );
  };

  renderExceededNumber = () => {
    const assets = window?.userInfo?.domainAccesses?.assets;
    if (assets && assets.length > 0) {
      const relatedAsset = assets?.find((x) => x.assetName == this.props.accessName);
      if (relatedAsset?.assetQty > 0 && relatedAsset?.assetType === 1) {
        return (
          <span className="kuika-domain-access-modal__message-text">
            Number exceeded: {relatedAsset.assetQty} for "{relatedAsset.assetName}".
          </span>
        );
      }
    }
    return <></>;
  };

  render(): ReactNode {
    return (
      <>
        <DefaultModal
          showModal={this.props.isDomainAccessModalOpen}
          closeModal={this.closeModal}
          firstHeader={
            this.props.accessName === "WorkflowMultipleProjects" ? "A process already exists" : "Upgrade plan"
          }
          secondHeader={
            this.props.accessName === "WorkflowMultipleProjects" ? "A process already exists" : "Upgrade plan"
          }
          centered={true}
        >
          {this.renderMessage()}
        </DefaultModal>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    isDomainAccessModalOpen: state.domainAccessModal.isDomainAccessModalOpen,
    accessName: state.domainAccessModal.accessName
  };
};

const mapDispatchToProps = (dispatch) => ({
  hideDomainAccessModal: () => dispatch(hideDomainAccessModal())
});

const domainAccessRequiredModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(withHistory<IDomainAccessRequiredModalProps>(DomainAccessRequiredModal));
export { domainAccessRequiredModal as DomainAccessRequiredModal };
